import { X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../config/translations';

function FilterChips({ filters, onRemoveFilter, productCount }) {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const activeFilters = [];

  if (filters.category) {
    activeFilters.push({
      key: 'category',
      label: `${t('category')}: ${filters.category}`,
      value: filters.category
    });
  }

  if (filters.brand) {
    activeFilters.push({
      key: 'brand',
      label: `${t('brand')}: ${filters.brand}`,
      value: filters.brand
    });
  }

  if (filters.minPrice) {
    activeFilters.push({
      key: 'minPrice',
      label: `${t('minPrice')}: ${filters.minPrice} Kč`,
      value: filters.minPrice
    });
  }

  if (filters.maxPrice) {
    activeFilters.push({
      key: 'maxPrice',
      label: `${t('maxPrice')}: ${filters.maxPrice} Kč`,
      value: filters.maxPrice
    });
  }

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        {/* Active Filters */}
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-gray-700">
            {t('activeFilters')}:
          </span>
          {activeFilters.map((filter) => (
            <button
              key={filter.key}
              onClick={() => onRemoveFilter(filter.key)}
              className="inline-flex items-center space-x-1 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium hover:bg-primary-200 transition-colors group"
              aria-label={`Remove filter ${filter.label}`}
            >
              <span>{filter.label}</span>
              <X className="w-4 h-4 group-hover:text-primary-900" aria-hidden="true" />
            </button>
          ))}
        </div>

        {/* Product Count */}
        {productCount !== undefined && (
          <div className="text-sm font-medium text-gray-600">
            {productCount} {productCount === 1 ? t('product') : t('products')}
          </div>
        )}
      </div>
    </div>
  );
}

export default FilterChips;
